import { z } from 'zod'

/** 會員資訊 Schema */
export const memberSchema = z.object({
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 會員名[英文] */
  englishFirstName: z.string(),
  /** 會員姓[英文] */
  englishLastName: z.string(),
  /** 姓名 */
  name: z.string(),
  /** 部門 */
  department: z.string()
})

/** 會員資訊 */
export interface Member extends z.infer<typeof memberSchema> {}
